import { parseDefiniteQuotationDTO, QuotationDTO } from 'components/ordering/quotation/api/dtos/quotation-dto.js'
import { StatusCodeToError } from 'components/ordering/quotation/api/dtos/error.js'
import { QuotationRequest } from 'components/ordering/quotation/api/quotation-request.js'

const EXPECTED_ERRORS = [400] as const
type ExpectedErrors = StatusCodeToError<typeof EXPECTED_ERRORS[number]>

type DeleteQuotationLinePayload = {
  quotationId: number
  lineId: number
}

export class DeleteQuotationLine extends QuotationRequest<QuotationDTO, ExpectedErrors> {
  path: string
  override init: RequestInit
  override expectedErrors = EXPECTED_ERRORS

  constructor({ quotationId, lineId }: DeleteQuotationLinePayload) {
    super()

    this.path = `quotation/${quotationId}/line/${lineId}/`
    this.init = {
      method: 'DELETE',
    }
  }

  override parseResponse = parseDefiniteQuotationDTO
}
